import { Box, Typography } from '@mui/material';
import { COLORS } from '../../../utils/Application_Constants';
import { formatPtsDetailCalculationError } from '../../Utils/validatePtsDetailCalculations';

const PtsDetailCalculationErrorsDisplay = ({ errors = [] }) => {
    if (!errors.length) {
        return null;
    }

    return (
        <Box
            sx={{
                my: 2,
                p: 2,
                borderRadius: 1,
                backgroundColor: COLORS.LT_PEPPER10,
                border: `1px solid ${COLORS.LT_PEPPER25}`,
            }}
        >
            <Typography color="error" variant="body2" fontWeight={600} mb={1}>
                Status cannot be changed because one or more PTS detail lines have calculation
                errors.
            </Typography>
            {errors.map((error) => (
                <Typography
                    key={`${error.entryId}-${error.side}`}
                    color="error"
                    component="pre"
                    variant="body2"
                    sx={{ whiteSpace: 'pre-wrap', mb: errors.length > 1 ? 2 : 0 }}
                >
                    {formatPtsDetailCalculationError(error)}
                </Typography>
            ))}
        </Box>
    );
};

export default PtsDetailCalculationErrorsDisplay;
